<!-- 地点选择 -->
<template>
  <div class="address-box">
    <!-- 头部导航条 -->
    <van-nav-bar title="地点" left-arrow fixed placeholder z-index="100" @click-left="onClickLeft">
      <template #left>
        <img src="@/assets/img/home/close.png" class="nav-img" />
      </template>
    </van-nav-bar>
    <!-- 地点选择 -->
    <div class="address-select">
      <div class="address-citys">
        <!-- 市级-->
        <ul class="citys-box">
          <li
            :class="{'active':cityId==item.district_id}"
            v-for="(item, index) in citys"
            :key="index"
            @click="selectArea(item.district_id,'0',item.name)"
          >{{item.name}}</li>
        </ul>
      </div>
      <div class="address-area">
        <!-- 区级-->
        <ul class="citys-box">
          <li
            v-for="(item, index) in areaList"
            :key="index"
            :class="{'active-area':areaId==item.district_id}"
            @click="selectArea(item.district_id,'1',item.name)"
          >{{item.name}}</li>
        </ul>
      </div>
      <div class="address-street">
        <!-- 街道 管事处 -->
        <ul class="citys-box">
          <li
            :class="{'active-street':streetId==item.district_id}"
            v-for="(item, index) in streetList"
            :key="index"
            @click="selectArea(item.district_id,'2',item.name)"
          >{{item.name}}</li>
        </ul>
      </div>
    </div>
    <!-- 按钮  -->
    <div style="height:1.3rem;"></div>
    <div class="btn">
      <button
        class="clear"
        @click="btnTips(0)"
        :style="showClear?'background:rgba(197,197,197,0.5)':''"
      >清除</button>
      <button
        class="confirm"
        :style="show?'background:rgba(255,67,67,0.5)':''"
        @click="btnTips(1)"
      >确定</button>
    </div>
  </div>
</template>

<script>
import { getAreaKinds } from "@/api/apiData";
import { Toast, Dialog } from "vant";
import { mapMutations, mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      citys: [],
      cityId: "",
      areaId: "",
      areaList: [],
      streetList: [],
      streetId: "",
      show: false,
      showClear: false,
      address: "",
      entrance: "" //0 首页 1搜索
    };
  },
  computed: { ...mapState(["selectInfo"]) },
  methods: {
    ...mapMutations(["selectAddress"]),
    //点击左侧导航栏按钮
    onClickLeft() {
      this.$router.back();
    },
    // 选择地区
    selectArea(val, type, name) {
      var that = this;
      switch (type) {
        case "0":
          that.cityId = val;
          that.address = name;
          that.getAddress(val, 1);
          break;
        case "1":
          that.areaId = val;
          that.address = name;
          that.getAddress(val, 2);
          break;
        case "2":
          that.streetId = val;
          that.address = name;
          break;
      }
    },
    // 获取地址
    getAddress(val, type) {
      var that = this;
      var parent_id = val;
      var obj = {
        parent_id: parent_id
      };
      getAreaKinds(obj).then(res => {
        // //(res);
        if (res.code == 1) {
          switch (type) {
            case 0:
              that.citys = res.data;
              that.cityId = res.data[0].district_id; //默认显示的市级
              // that.address = res.data[0].name;
              that.getAddress(that.cityId, 1);
              break;
            case 1:
              that.areaList = res.data;
              that.areaId = res.data[0].district_id; //默认显示的区级
              that.address = res.data[0].name;
              that.getAddress(that.areaId, 2);
              break;
            case 2:
              that.streetList = res.data;
              // that.streetId = res.data[0].district_id; //默认显示的街道
              // that.address=res.data[0].name
              break;
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    // 按钮
    btnTips(val) {
      if (val == 0) {
        // 清除
        if (this.selectInfo.length == 0) {
          Dialog.alert({
            title: "提示",
            message: "您还没有选择地区哦~"
          }).then(() => {});
        } else {
          Dialog.confirm({
            title: "提示",
            message: "确定要清除已选择的地区吗？"
          })
            .then(() => {
              this.getAddress("", 0);
              this.selectAddress(["", "", 0, "type"]);
              var scrollTop =
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                window.pageYOffset;
              scrollTop = 0;
              this.showClear = true;
              setTimeout(() => {
                this.showClear = false;
              }, 100);
              Toast.success({
                forbidClick: true,
                message: "清除成功"
              });
            })
            .catch(() => {
              // on cancel
            });
        }
      } else {
        // 确认
        this.show = true;
        setTimeout(() => {
          this.show = false;
        }, 100);
        if (this.cityId != "" && this.areaId == "") {
          //  全市
          var id = this.cityId;
          var number = 0;
        }
        if (this.cityId != "" && this.areaId != "" && this.streetId == "") {
          var id = this.areaId;
          var number = 1;
        }
        if (this.cityId != "" && this.areaId != "" && this.streetId != "") {
          var id = this.streetId;
          var number = 2;
        }
        var addres = [this.address, id, this.entrance];
        this.selectAddress(addres);
        this.$router.back();
      }
    }
  },
  created() {
    if (this.$route.query) {
      this.entrance = this.$route.query.entrance;
    } else {
      this.entrance = this.$route.params.entrance;
    }
  },
  mounted() {
    this.getAddress("", 0);
  }
};
</script>
<style lang='less' scoped>
.nav-img {
  width: 0.4rem;
  height: 0.4rem;
}
//地点选择
.address-select {
  display: flex;
  .address-citys,
  .address-area,
  .address-street {
    flex: 3;
    background: #fff;
    .citys-box {
      font-size: 0.28rem;
      font-weight: 400;
      line-height: 0.4rem;
      color: rgba(51, 51, 51, 1);
      max-height: 12rem;
      overflow: auto;
      overflow-y: scroll;
      li {
        position: relative;
        padding: 0.3rem 0;
        display: flex;
        align-items: center;
        margin-left: 0.36rem;
        padding-right: 0.3rem;
      }
      .active::before {
        content: "";
        display: inline-block;
        width: 0.08rem;
        height: 0.24rem;
        background: #ff4343;
        border-radius: 0.02rem;
        position: absolute;
        left: -0.36rem;
      }
    }
  }
  .address-area {
    background: rgba(248, 248, 250, 1);
    .active-area {
      color: #ff4343;
    }
  }
  .address-street {
    flex: 4;
    background: rgba(242, 242, 245, 1);
    .active-street {
      color: #ff4343;
    }
    .active-street::after {
      content: "\2714";
      font-size: 0.4rem;
      margin-left: 0.3rem;
    }
  }
}
</style>